import { render, staticRenderFns } from "./VisitNotesForm.vue?vue&type=template&id=5f03d552&"
import script from "./VisitNotesForm.vue?vue&type=script&lang=js&"
export * from "./VisitNotesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports